// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".workspace-line[data-v-b89bc71e]{position:absolute;pointer-events:none;z-index:3}.active[data-v-b89bc71e]{z-index:4!important}", ""]);
// Exports
module.exports = exports;
